import React from "react";
import { Box, Typography, Table, Sheet, Card } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { PlaceInfoCard } from "UI/Grids";
import SwipeComponent from "Components/hoc/SwipeComponent";
import { HideSectionButton } from "forms/places";

const Hebergement = ({ uid, espaces, sections, placeId }) => {
	console.log(sections);
	const { t } = useTranslation();

	return (
		<>
			<Box>
				<Typography
					level="h4"
					sx={(theme) => ({
						mb: 2,
						textAlign: "left",
						color: theme.vars.palette.primary[600],
					})}
				>
					{t("spaces")}
				</Typography>

				<HideSectionButton
					section="espaces"
					placeId={placeId}
					uid={uid}
					sectionsVisibility={sections}
				/>
				<Box sx={{ overflow: "auto", pt: 2, pb: 2 }}>
					<SwipeComponent>
						{espaces &&
							espaces.map((e, index) => (
								<PlaceInfoCard
									key={`espace_${index}`}
									image={e?.image}
									title={e?.nom}
									description={e?.description}
								/>
							))}
					</SwipeComponent>
				</Box>
			</Box>
		</>
	);
};

export default Hebergement;
